import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faRecycle, faTimes, faTrashAlt, faPaperclip, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';
import { Button, CardLink, Col, Container, Fade, Row, Input } from "reactstrap";
import { DateRangePicker } from 'react-date-range';
import { messageBoardAction } from '../../actions/messageBoardAction';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import ReactPaginate from 'react-paginate';
import { showAlert, handleDownloadZip } from "../common/functions";
import { DABBackToList, ConfirmModal, LoadingSpinnerModal, DABTextBox } from '../../components/dab';

interface ITopicsProps {
	dispatch: Dispatch<any>;
	messageBoardData: any;
	id: number;
	code: any;
	userData: any;
	callback: any;
}

const Topics: React.SFC<ITopicsProps> = ({
	dispatch, messageBoardData, id, code, callback }) => {

	const initialInputValue = {
		messageBoardId: id,
		uniqueCode: code,
		userId: -1,
		sortColumn: "",
		pageNumber: 1,
		pageSize: 25,
		sortDirection: "desc",
		startDateUtc: "",
		endDateUtc: "",
		isDeleted: false,
		isNotDeleted: true,
		authorName: ''
	};
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [pageList, setPageList] = useState([1]);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [authorSearchText, setAuthorSearchText] = useState('');
	const [visible, setVisible] = useState(false);
	const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

	var tokenstr = (new URLSearchParams(window.location.search))?.get("code");

	const handleToggle = async () => {
		await setFadeIn(!fadeIn)
	};

	const handleDownload = async () => {
		setShowModal(true)
		let allAttachement = [null]
		topicsList.map((value: any) => allAttachement.push(value.attachment))
		await handleDownloadZip(allAttachement)
		setShowModal(false)
	}

	const [initialDate] = useState([
		{
			endDate: new Date(),
			startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 2)),
			key: 'selection'
		}
	]);
	const [dateRange, setDateRange] = useState(initialDate);
	const [topicsList, settTopicsList] = useState([]);
	const [selectedId, setSelectedId] = useState(0);
	const defaultAuthValue = [{ text: "", value: 0, checked: false }];
	const [authorsList, setAuthorsList] = useState(defaultAuthValue);
	const [selectedAuthor, setSelectedAuthor] = useState(-1);
	const [isDeleted, setIsDeleted] = useState(false);
	const [isNotDeleted, setIsNotDeleted] = useState(true);
	const [isNotPublic, setIsNotPublic] = useState(false);

	React.useEffect(() => {
		setShowModal(true);

		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'topic') {
			handleFilterRestore();
		}

		if (initialInputValue != filterInput) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput));
		} else {
			sessionStorage.removeItem("Filter");
		}

		dispatch(messageBoardAction.messageBoardGetTopicByFilter(filterInput));
	}, [filterInput]);

	const history = useHistory();

	const handleBackClick = (event) => {
		event.preventDefault();
		history.goBack();
	}

	const handleFilterClear = () => {
		setFadeIn(false);
		setIsDeleted(false);
		setIsNotDeleted(true);
		setShowClearFilter(false);
		setAuthorSearchText("");
		setFilterInput(initialInputValue);
		setSelectedAuthor(0);
		setCurrentPageNo(0);
		setDateRange(initialDate);
		setIsDeleted(false);
		setIsNotDeleted(true);
		sessionStorage.removeItem("Filter")
	}

	const handleFilter = () => {
		if ((code != "" || id > 0)) {
			filterInput.isDeleted = isDeleted;
			filterInput.isNotDeleted = isNotDeleted
			filterInput.userId = selectedAuthor;
			filterInput.pageNumber = 1,
				filterInput.startDateUtc = moment(dateRange[0].startDate.toISOString()).format("YYYY-MM-DD");
			filterInput.endDateUtc = moment(dateRange[0].endDate.toISOString()).format("YYYY-MM-DD");
			filterInput.authorName = authorSearchText;
			setShowModal(true);
			setFilterInput({ ...filterInput });
		}
		setShowClearFilter(true);
		handleToggle()
		setCurrentPageNo(0);
	}

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setIsDeleted(filterObj.isDeleted);
				setIsNotDeleted(filterObj.isNotDeleted);
				setDateRange([{ endDate: new Date(filterObj.endDateUtc), startDate: new Date(filterObj.startDateUtc), key: 'selection' }])
				setFilterInput(filterObj);
				setShowClearFilter(true);
				setCurrentPageNo(filterObj.pageNumber - 1)
			}
			sessionStorage.removeItem("fromPage");
		}
	}

	const updateShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const sort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
		messageBoardData.isTopicsLoaded = false;
	};

	const setPageNumber = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { sort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handlePageClick = (data) => {
		setPageNumber(data.selected + 1);
		setCurrentPageNo(data.selected);
	};

	if (messageBoardData && messageBoardData.isSuccess) {
		if (messageBoardData.isTopicsLoaded) {
			if (messageBoardData.topicsData) {
				callback(messageBoardData.topicsData.title + " - Posts")
				settTopicsList(messageBoardData.topicsData.topics)
				setIsNotPublic(messageBoardData.topicsData.isPrivate)
				if (!showClearFilter) {
					setDateRange([{
						endDate: new Date(messageBoardData.topicsData.maxDate),
						startDate: new Date(messageBoardData.topicsData.minDate),
						key: 'selection'
					}])
				}
				var total: number = messageBoardData.topicsData.totalCount;
				var pList: number[] = [];
				if (total > initialInputValue.pageSize) {
					for (var i = 1; i < (total / initialInputValue.pageSize); i++) {
						pList.push(i);
					}
					if ((total % initialInputValue.pageSize) > 0) {
						pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
					}
				}
				else {
					pList.push(1);
				}
				setPageList(pList);
			}
			messageBoardData.isTopicsLoaded = false;
			setShowModal(false);
		}
	}


	const handleLoadShowModal = (value: boolean, isModelClose: boolean) => {
		if (value) {
			dispatch(messageBoardAction.messageBoardTopicDelete(selectedId));
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handlePostDelete = (id: number) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	}

	if (messageBoardData && !messageBoardData.isSuccess && messageBoardData.isError) {
		messageBoardData.isError = false;
		if (messageBoardData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(messageBoardData.status, true);
		}
		setShowModal(false);
	}

	if (messageBoardData && messageBoardData.isSuccess && (messageBoardData.isTopicDeleted || messageBoardData.isTopicRestored)
		&& !messageBoardData.isError) {
		showAlert(messageBoardData.status, false);
		messageBoardData.isSuccess = false;
		if (messageBoardData.isTopicDeleted)
			messageBoardData.isTopicDeleted = false;
		if (messageBoardData.isTopicRestored)
			messageBoardData.isTopicRestored = false;
		dispatch(messageBoardAction.messageBoardGetTopicByFilter(filterInput));
		if (selectedId > 0)
			setSelectedId(-1);
		setShowModal(false);
	}

	if (messageBoardData && messageBoardData.isSuccess && !messageBoardData.isError) {
		if (messageBoardData.authors && messageBoardData.authors.length > 0) {
			var options: any[] = [];
			var item = { text: "Select", value: 0, checked: true };
			options.push(item);
			messageBoardData.authors.forEach((data) => {
				item = { text: data.name, value: data.userId, checked: false };
				options.push(item);
			});
			setAuthorsList(options);
			setShowModal(false);
		}
		messageBoardData.isSuccess = false;
	}

	const handleRestore = (id: number) => {
		setShowModal(true);
		dispatch(messageBoardAction.messageBoardTopicRestore(id))
	}

	const handleChangeSearchText = (e) => {
		setAuthorSearchText(e.target.value)
	}

	const handleTopicDetailClick = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			sessionStorage.setItem("fromPage", "topic")
		}
	}

	const showTooltip = () => {
		setVisible(true);
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => setVisible(false), 5000);
	};

	const toggleTooltip = () => {
		setVisible(prev => !prev);
		if (!visible) {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => setVisible(false), 5000);
		}
	};

	const hideTooltip = () => {
		if (timeoutRef.current) clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => setVisible(false), 300);
	};

	return (
		<div className="forum-topic">
			<div className='card-box'>
				<DABBackToList data-testid="backToList" onClick={(e) => { handleBackClick(e); }} />
				<Col lg="8" className='column'>
					<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
					{tokenstr ==="hotline"&&<CardLink onClick={handleDownload} className='card-box-link'>Download All Attachments</CardLink>}
					{showClearFilter ?
						<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
						: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
				</Col>
				{fadeIn && (
					<Fade in={fadeIn} tag="h5" className='card-fade'>
						<Container className='filter-container'>
							<div className='box-container'>
								<div className='pb'>
									<Row>
										<Col lg="4">
											<div>
												<label>Status</label>
												<div className='filterRow'>
													<Input type="checkbox" className='box-container-input' checked={isNotDeleted}
														onChange={(e) => { setIsNotDeleted(e.target.checked) }}
													/>
													<span>Not Deleted</span>
												</div>
												<div className='filterRow'>
													<Input type="checkbox" className='box-container-input' checked={isDeleted}
														onChange={(e) => { setIsDeleted(e.target.checked) }}
													/>
													<span>Deleted</span>
												</div>
											</div>
										</Col>
										<Col lg="5">
											<label>Author</label>
											<div>
												<DABTextBox type="search" id="searchText" isRequired={false} onChange={handleChangeSearchText} value={authorSearchText} />
											</div>
											<div className="wildcard-info">
												<FontAwesomeIcon icon={faInfoCircle} onClick={toggleTooltip} onMouseEnter={showTooltip} className="info-icon"
													onMouseLeave={hideTooltip} />  Use <code>*</code> as a wildcard. Search first name, last name, or displayname.<br />
												{visible && (
													<div onMouseEnter={() => { if (timeoutRef.current) clearTimeout(timeoutRef.current); }}
														onMouseLeave={hideTooltip} className='info-panel'>
														<strong>Examples:</strong><br />
														• <code>an* fleming</code> → Angela Fleming, Ann Fleming, Androw Fleming<br />
														• <code>an* flem*</code> → Angela Fleming, Ann Fleming, Androw Fleming<br />
														• <code>john*</code> → John, Johnny, Johnson, John David<br />
														• <code>methew</code> → Methew, Methew Fleming, Jan Methew<br /><br />
													</div>
												)}
											</div>
										</Col>
										<Col lg="3">
											<div className='close-div'>
												<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" size='3x'
													title="Close" icon={faTimes} onClick={handleToggle} />
											</div>
										</Col>
									</Row>
								</div>
								<Row>
									<Col lg="11">
										<label>Date</label>
										<div >
											<DateRangePicker className="calender"
												onChange={item => setDateRange([item.selection])}
												showSelectionPreview={false}
												moveRangeOnFirstSelection={false}
												months={2}
												ranges={dateRange}
												direction="horizontal"
											/>
										</div>
									</Col>
									<Col lg="1">
										<Button id="submit" className="inner-filter-link" onClick={handleFilter}>Filter</Button>
									</Col>
								</Row>
							</div>
						</Container>
					</Fade>)}
			</div>
			<div className="topic-table">
				<table data-testid="topicTable" className="table table-hover text-center">
					<thead>
						<tr className="tr">
							<th scope="col" >Messages</th>
							<th scope="col" >{handleGetSortColumn("Subject", "TOPIC")}</th>
							{isNotPublic ? (
								<>
									<th scope="col">Attachment</th>
								</>
							) : (
								<>
									<th scope="col" >{handleGetSortColumn("Replies", "REPLY")}</th>
									<th scope="col">{handleGetSortColumn("Reports", "REPORT")}</th>
								</>
							)}
							<th scope="col" >{handleGetSortColumn("Author", "AUTHOR")}</th>
							<th scope="col" >{handleGetSortColumn("Created", "CREATEDAT")}</th>
							<th scope="col" >Delete</th>
						</tr>
					</thead>
					<tbody data-testid="topicTableBody">
						{topicsList && topicsList.length > 0 ?
							topicsList && topicsList.map((data: any) =>
								<tr key={data.topicId} className={`tr ${data.isDeleted ? 'topic-inactive' : 'topic-active'}`} >
									<th id={"postIcon" + data.topicId} scope="row">
										<a href={`/messageboard?page=posts&id=${data.topicId}`} className="detail-link" onClick={handleTopicDetailClick}>
											<FontAwesomeIcon data-testid={"postFaIcon" + data.topicId} cursor='pointer' size='2x' icon={faComments} title="Topic Messages" />
										</a>
									</th>
									<td id={"topicName" + data.topicId} className='col-align-left'>
										<a href={`/messageboard?page=posts&id=${data.topicId}`} className="detail-link" data-testid={"subject" + data.topicId}
											onClick={handleTopicDetailClick}>{data.topicName}</a>
									</td>
									{isNotPublic ? (
										<td id={"attachment" + data.topicId}>
											{data.attachment ? (
												<a
													href={data.attachment}
													className="detail-link"
													target="_blank"
													rel="noopener noreferrer"
													title="View Attachment"
												>
													<FontAwesomeIcon id={"attachmentIcon" + data.topicId}
														cursor='pointer' size='2x' icon={faPaperclip}
														data-bs-toggle="tooltip"
														data-testid="topicDeleteButton"
														data-bs-placement="bottom" title="View Attachment"/>
												</a>
											) : (
												"No Attachment"
											)}
										</td>
									) : (
										<>
											<td id={"replyCount" + data.topicId}>{data.replyCount}</td>
											<td id={"reports" + data.topicId}>{data.reportedCount}</td>
										</>
									)}
									<td id={"author" + data.topicId}><a href={"/dashboard?id=" + data.authorId} className="detail-link" data-testid={"author" + data.topicId}>{data.author}</a></td>
									<td id={"createdAtUtc" + data.topicId} className='col-nowrap'>
										{moment(data.createdAtUtc).format('LL')}
									</td>
									<td id={"delete" + data.topicId}>
										{!data.isDeleted ? <FontAwesomeIcon id={"deleteIcon" + data.topicId} cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
											data-testid="topicDeleteButton"
											data-bs-placement="bottom" title="Delete" onClick={() => { handlePostDelete(data.topicId); }} /> :
											<FontAwesomeIcon id={"restoreIcon" + data.topicId} cursor='pointer' size='2x' icon={faRecycle} title="Restore"
												onClick={() => { handleRestore(data.topicId); }} data-testid="topicRestore" />}
									</td>
								</tr>
							) : <td colSpan={7} className="border-bottom-0" ><h4 className="text-center mt-5">No data found</h4></td>}
					</tbody>
				</table>
			</div>

			<div className="pagination">
				<ReactPaginate
					previousLabel={'<<'}
					nextLabel={'>>'}
					breakLabel={'...'}
					pageCount={pageList.length}
					marginPagesDisplayed={2}
					pageRangeDisplayed={10}
					onPageChange={handlePageClick}
					forcePage={currentPageNo}
					containerClassName={'pagination'}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={'active'}
				/>
			</div>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={updateShowModal} />
				)
			}
			<ConfirmModal isShowModal={showDeleteModal}
				deleteMessage={"Deleting a message will delete the message and all replies. Are you sure you want to do this? "} modalChange={handleLoadShowModal} />
		</div>
	);
};


const mapStateToProps = (state: any) => {
	const { messageBoardData, userData } = state;
	return {
		messageBoardData, userData
	};
};

export default connect(mapStateToProps)(Topics);